// extracted by mini-css-extract-plugin
export var actionButton = "_cs-t";
export var buttonContainer = "_cs-0";
export var buttonContainer2 = "_cs-1";
export var buttonSection = "_cs-2";
export var details = "_cs-3";
export var dropdownItem = "_cs-5";
export var dropdownItemsContainer = "_cs-4";
export var fileInput = "_cs-r";
export var headerButton = "_cs-6";
export var icon = "_cs-7";
export var input = "_cs-8";
export var macroListItem = "_cs-9";
export var mainContent = "_cs-a";
export var microText = "_cs-b";
export var modal = "_cs-w";
export var optionsButton = "_cs-c";
export var paperclip = "_cs-s";
export var pillContent = "_cs-d";
export var preview = "_cs-e";
export var preview2 = "_cs-f";
export var quillEditor = "_cs-q";
export var selectedMacro = "_cs-g";
export var sidebar = "_cs-h";
export var sidebarHeader = "_cs-j";
export var sidebarList = "_cs-i";
export var sidebarListItem = "_cs-k";
export var sidebarSearch = "_cs-l";
export var snoozeDurationWrapper = "_cs-v";
export var statusPillContainer = "_cs-m";
export var tagsContainer = "_cs-n";
export var unselectedMacro = "_cs-o";
export var variable = "_cs-u";
export var wrapper = "_cs-p";